import { BasicAsyncEnumerable } from "../BasicAsyncEnumerable.js";
export const ofType = (source, type) => {
    const typeCheck = typeof type === "string" ?
        ((x) => typeof x === type) :
        ((x) => x instanceof type);
    async function* iterator() {
        for await (const item of source) {
            if (typeCheck(item)) {
                yield item;
            }
        }
    }
    return new BasicAsyncEnumerable(iterator);
};
